// Cognito redirects here.

// We find most recently used tenant and identity provider in sessionstorage,
// set up an AuthProvider with those, and then redirect to the tenant's
// main page once login is complete.

import { useNavigate } from "react-router";

import {
  SESSION_KEY_RECENT_IDENTITY_PROVIDER,
  SESSION_KEY_RECENT_PATH,
  SESSION_KEY_RECENT_TENANT,
} from "../auth-constants";
import { AuthProviderForIdentityProvider } from "../providers/auth-provider-for-tenant-and-provider";

interface CognitoCallbackPageProps {
  oauthRedirectUrlPrefix?: string;
}

export function CognitoCallbackPage({ oauthRedirectUrlPrefix }: CognitoCallbackPageProps) {
  const navigate = useNavigate();

  const recentTenant = window.sessionStorage.getItem(SESSION_KEY_RECENT_TENANT);
  const recentIdentityProvider = window.sessionStorage.getItem(
    SESSION_KEY_RECENT_IDENTITY_PROVIDER
  );
  const recentPath = window.sessionStorage.getItem(SESSION_KEY_RECENT_PATH);

  if (!recentTenant || !recentIdentityProvider) {
    console.error("No recent authentication information found.");
    navigate("/");
    return null;
  }

  return (
    <AuthProviderForIdentityProvider
      tenant={recentTenant}
      identityProvider={recentIdentityProvider}
      authConfig={{
        autoLogin: false,
        postLogin: () =>
          setTimeout(() => navigate(recentPath ?? `/${recentTenant}`, { replace: true }), 0),
      }}
      oauthRedirectUrlPrefix={oauthRedirectUrlPrefix}
    />
  );
}
